import React from 'react'

function About() {
	return (
		<div className="empty-page">
			<h1 className='text-center mt-3'>About</h1>
		</div>
	)
}

export default About
